import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/success-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6328f8a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redeem-dialog pb-0 px-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mb-3",
  src: _imports_0,
  alt: "success-icon"
}, null, -1))
const _hoisted_3 = { class: "title text-black fw-semibold mb-2" }
const _hoisted_4 = { class: "des" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString($setup.local.my_points_36), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString($setup.local.my_points_37), 1),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.hide_ && $setup.hide_(...args))),
      class: "knew-btn border-0 rounded-5 text-white mb-3 py-2 fw-semibold fs-6"
    }, _toDisplayString($setup.local.my_points_38), 1)
  ]))
}